import { Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Tooltip, SpeedDial } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import EventIcon from '@mui/icons-material/Event';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useUtiles } from "../../../../shared/context/utilesContext";
import ManageTaskScheduledComponent from "./ManageTaskScheduledComponent";
import ProgrammingTaskComponent from "./ProgrammingTaskComponent";
import { useScheduled } from "../../../../shared/context/scheduledContext";
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect } from "react";

export default function TareasComponent() {
    const theme = useTheme()
    const navigate = useNavigate()
    const isMobile = useMediaQuery('(max-width: 600px)')
    const { openSilderWith } = useUtiles()
    const { groupScheduledTasks, setTaskScheduled, setSubtaskScheduled, setSubtaskScheduledList, resetSubtaskScheduled, resetTaskScheduled, deleteTaskTemplate, setProgramTask, programTask } = useScheduled()



    const handleOpenCreateTask = () => {
        openSilderWith(<ManageTaskScheduledComponent />, 700, 'Crear Tarea')
        resetSubtaskScheduled()
        resetTaskScheduled()
    }

    useEffect(() => {
        console.log(programTask)
    }, [programTask])

    const handleOpenProgrammingTask = (event, task) => {
        event.stopPropagation()
        openSilderWith(<ProgrammingTaskComponent readOnly={task.assigned_to_ot}  />, 700, 'Programar tarea')
        setProgramTask({...programTask, 
            task_scheduled: task, 
            group_scheduled_hash: task.group_scheduled_hash,
            frequency: task.programmer_dates[0]?.frequency || null, 
            dates_programmed: task.programmer_dates.length > 0 ? task.programmer_dates.map(date => ({
                datetime_start_estimated: date.datetime_start_estimated,
                datetime_end_estimated: date.datetime_end_estimated,
                id: date.id,
            })) : [],
            programmer_dates_created: task.programmer_dates_created,

        })
    }

    const handleDeleteTaskTemplate = (event, hash_code) => {
        event.stopPropagation()
        deleteTaskTemplate(hash_code)
    }


    //editar tarea
    const handleOpenEditTask = (task) => {
        setTaskScheduled(task)
        setSubtaskScheduledList(task.subtasks)
        openSilderWith(<ManageTaskScheduledComponent task={task} />, 700, 'Editar tarea')
        console.log(task)
    }

    return (
        <Box sx={{ p: { xs: 0.5, md: 2 }, pb: { xs: 0, md: 2 }, position: 'relative' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '12px', color: theme.palette.text.primary, mb: 1 }}>Tareas:</Typography>

            <TableContainer sx={{ maxHeight: 600, minHeight: "600px", width: '100%' }}>
                <Table sx={{ minWidth: 1200, overflowX: 'auto' }} aria-label="simple table" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '70px' }}></TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Descripción de la tarea</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '100px' }}>Tipo de tarea</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '100px' }}>Clasificación 1</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '100px' }}>Clasificación 2</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '100px' }}>Prioridad</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '100px' }}>Tiempo estimado</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '80px' }}>Requiere SSOMA</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody >
                        {groupScheduledTasks.map((task) => (
                            <TableRow key={task.id} sx={{ cursor: 'pointer', "&:hover": { backgroundColor: theme.palette.background.default } }} onClick={() => handleOpenEditTask(task)}>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '70px' }}>
                                    <Box sx={{ display: 'flex', gap: '10px' }}>
                                        <Tooltip
                                            title="Programar tarea"
                                            arrow
                                            placement="right"
                                            sx={{
                                                backgroundColor: theme.palette.background.paper,
                                                boxShadow: theme.shadows[2],
                                                fontSize: '12px'
                                            }}

                                        >
                                            <IconButton
                                                onClick={(event) => handleOpenProgrammingTask(event, task)}
                                                sx={{
                                                    backgroundColor: theme.palette.primary.main,
                                                    color: '#fff',
                                                    '&:hover': {
                                                        backgroundColor: theme.palette.primary.main,
                                                        transform: 'scale(1.05)',
                                                        transition: 'transform 0.2s'
                                                    }
                                                }}
                                                size="small"
                                            >
                                                <EventIcon />
                                            </IconButton>
                                        </Tooltip>
                                       { !task.assigned_to_ot && <Tooltip
                                            title="Eliminar tarea template"
                                            arrow
                                            placement="right"
                                            sx={{
                                                backgroundColor: theme.palette.background.paper,
                                                boxShadow: theme.shadows[2],
                                                fontSize: '13px'
                                            }}
                                        >
                                            <IconButton onClick={(event) => handleDeleteTaskTemplate(event, task.hash_code)} size="small"
                                                sx={{
                                                    backgroundColor: theme.palette.error.main,
                                                    color: '#fff',
                                                    '&:hover': {
                                                        backgroundColor: theme.palette.error.main,
                                                        transform: 'scale(1.05)',
                                                        transition: 'transform 0.2s'
                                                    }
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>}
                                    </Box>
                                </TableCell>
                                <TableCell sx={{ fontWeight: 'normal', backgroundColor: theme.palette.background.paper, width: '200px' }}> {task.description}</TableCell>
                                <TableCell sx={{ fontWeight: 'normal', backgroundColor: theme.palette.background.paper, width: '100px' }}>{task.typeTask.value}</TableCell>
                                <TableCell sx={{ fontWeight: 'normal', backgroundColor: theme.palette.background.paper, width: '100px' }}>{task.classification_1?.value} </TableCell>
                                <TableCell sx={{ fontWeight: 'normal', backgroundColor: theme.palette.background.paper, width: '100px' }}>{task.classification_2?.value}</TableCell>
                                <TableCell sx={{ fontWeight: 'normal', backgroundColor: theme.palette.background.paper, width: '100px' }}>{task.priority}</TableCell>
                                <TableCell sx={{ fontWeight: 'normal', backgroundColor: theme.palette.background.paper, width: '100px' }}>{task.time_duration}</TableCell>
                                <TableCell sx={{ fontWeight: 'normal', backgroundColor: theme.palette.background.paper, width: '80px' }}>{task.required_ssoma_document}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>

                </Table>
            </TableContainer>

            <SpeedDial
                ariaLabel="Add"
                sx={{ position: 'absolute', bottom: isMobile ? 40 : 30, right: 8 }}
                icon={<AddIcon />}
                direction="right"
                openIcon={<AddIcon />}
                onClick={handleOpenCreateTask}
            />
        </Box>
    )
}